import React, { Fragment, useEffect, useState } from 'react';
import PageHeaderText from 'components/base/page-header-text';
import { Link, useParams } from 'react-router-dom';

import { MAIN_STORE_ROUTE_KEYS } from 'utils/constants';
import { apiService } from 'services/base.service';
import RequestStatusTag from 'components/base/request-status-tag';
import useDashboardContext from 'contexts/dashboard.context';
import { ENUM_REQUEST_STATUS } from 'models/common.model';
import { EditAltIcon } from 'cokitchen-icons';
import { RequestType } from 'models/item-request.model';

const ItemRequestDetails = () => {
  const { setIsBackLink, setBackLinkTitle } = useDashboardContext();
  const [requestItem, setRequestItem] = useState({} as RequestType);
  const [loading, setLoading] = useState(false);
  const { id } = useParams();
  useEffect(() => {
    setIsBackLink(true);
    setBackLinkTitle('Return to internal procurement requests');
    return () => {
      setIsBackLink(false);
      setBackLinkTitle('');
    };
  }, []);
  const getRequestDetails = async () => {
    setLoading(true);
    try {
      const res: any = await apiService.get(`kitchen-store/requests/${id}`, { version: 'v2' });
      setRequestItem(res.data.data);
    } catch (e: any) {
      console.log(e, 'error');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getRequestDetails();
  }, []);

  const is_complete = requestItem?.status === ENUM_REQUEST_STATUS.RECEIVED;

  return (
    <div>
      <PageHeaderText
        title={`Request #${requestItem?.code ?? '-'} `}
        description='Update items that have been sent or review  list'
        className='md:max-w-[670px]'>
        <RequestStatusTag status={requestItem.status} />
      </PageHeaderText>
      {loading ? (
        <div>
          <p> Loading...</p>
        </div>
      ) : !requestItem ? (
        <div>
          <p>No request item found</p>
        </div>
      ) : (
        <div className='border-4 border-[#F7F7F8] rounded py-[24px]  md:max-w-[670px]'>
          <div className='flex justify-between px-[28px]'>
            <div className=' pb-5'>
              <p className='font-semibold text-[24px] '>
                {is_complete ? 'Completed request' : 'Update request'}
              </p>
              <p className='text-[#6F7376] text-sm'>
                Update items that have been sent or review list
              </p>
            </div>
            {requestItem?.status !== ENUM_REQUEST_STATUS.COMPLETED &&
              requestItem?.status !== ENUM_REQUEST_STATUS.SENT && (
                <Link
                  className='bg-[#F2F2F3] rounded-full p-3 h-fit w-fit'
                  to={`${MAIN_STORE_ROUTE_KEYS.ITEM_REQUESTS}/review/${requestItem?.id}`}>
                  <EditAltIcon
                    className={`cursor-pointer rounded-full   text-[#6F7376]  hover:bg-gray-1 w-5 h-5 transition-all `}
                  />
                </Link>
              )}
          </div>
          {requestItem?.items?.map((item, index) => (
            <div
              className='flex justify-between items-center py-[24px] px-[28px] border-b border-b-[#F7F7F8]'
              key={index}>
              <div>
                <p className='text-[16px] font-semibold pb-[4px] '>{item.ingredient.name}</p>
                <div className='flex gap-[6px] items-center text-sm'>
                  <Fragment>
                    <p className='font-medium '>
                      {item.quantity} {item.unit_type || 'gram'} requested
                    </p>
                    {item.quantity_sent ? (
                      <>
                        {' '}
                        <div className='bg-[#D9D9D9] w-[6px] h-[6px] rounded-full' />
                        <p className=' text-[#0080E5]'>
                          {item.quantity_sent} {item.unit_type || 'gram'} sent
                        </p>
                      </>
                    ) : (
                      ''
                    )}

                    {item.quantity_received ? (
                      <>
                        {' '}
                        <div className='bg-[#D9D9D9] w-[6px] h-[6px] rounded-full' />
                        <p className=' text-[#0080E5]'>
                          {item.quantity_received} {item.unit_type || 'gram'} received
                        </p>
                      </>
                    ) : (
                      ''
                    )}
                  </Fragment>
                </div>
              </div>
              <RequestStatusTag status={item.status.toUpperCase() as ENUM_REQUEST_STATUS} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ItemRequestDetails;
